import { BaseFilter } from 'src/app/sharedFeatures/models/base-filter.model';
export class MileStoneLookupSearchModel extends BaseFilter {
  name!: string;
  description!: string;
  budget?: number | null;
  deadLine!: Date;
  projectId!: number;
  isCriticalPath: boolean = false;
}
